import styled from 'styled-components/macro';

export const PlayerCell = styled.div`
  color: ${({ theme, hovered }) => (hovered ? theme.coral : '')};
  font-size: ${({ theme }) => theme.h5}px;
  cursor: default;
  transition: color 0.2s;
`;

export const SubstituteCell = styled.div`
  width: 100%;
  display: flex;
`;

export const SubstituteLabel = styled.div`
  font-size: ${({ theme }) => theme.h5}px;
  font-family: ${({ theme, bold }) =>
    bold ? theme.primaryfontBold : theme.primaryFontMedium};
  margin-right: ${({ bold }) => (bold ? 0 : 5)}px;
`;

export const SquadContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row-reverse;

  > div {
    thead th {
      padding-bottom: 30px;
    }
  }
`;

export const Scroll = styled.div`
  width: 100%;
  max-height: 500px;
  overflow: hidden;

  .scroll-content {
    height: 100%;
    overflow-y: ${({ withScroll }) => (withScroll ? 'scroll' : 'hidden')};

    ::-webkit-scrollbar {
      width: 5px;
    }

    ::-webkit-scrollbar-track {
      background: #c4c4c5;
      border-radius: 10px;
    }

    ::-webkit-scrollbar-thumb {
      background: #666;
      border-radius: 10px;
    }

    ::-webkit-scrollbar-thumb:hover {
      background-color: ${({ theme }) => theme.darkWithOpacity};
    }

    table {
      padding-top: 0;
    }

    > div {
      height: 170%;
    }
  }
`;
